module.exports = __webpack_public_path__ + "img/baSys.3f8e6160.png";